module.exports = __webpack_public_path__ + "static/media/05_stuck_balls.728677df.jpg";